module.exports = class UpdateSelect {

    constructor(select) {

        this.select = select;
        this.span = this.select.previousElementSibling;

        if (select.selectedIndex != 0) {

            this.clearStyle(this);

        } else {
        
            this.Slider(this);

        }

        this.span.style.color = 'rgba(255, 255, 255, 0.5)';

        this.sliderSelect = window.setInterval(this.Slider.bind(this), 3000);

        if (select.selectedIndex != 0) {

            this.clearStyle(this);

        }

        this.select.addEventListener("change", this.Update.bind(this));

    }

    clearStyle () {

        clearInterval(this.sliderSelect);
        this.span.style.color = 'rgba(255, 255, 255, 1)';
        this.span.style.width = 'auto';

    }
    
    Slider() {

        let option = this.select.options.length;
        let randomNumber = Math.floor(Math.random() * (option - 1)) + 1;
        
        this.span.style.width = 'auto';

        this.span.innerHTML = this.select.options[randomNumber].textContent;

        this.span.style.width = this.span.clientWidth + 'px';

    }

    Update() {

        this.clearStyle(this);

        this.span.innerHTML = this.select.options[this.select.selectedIndex].textContent;

    }
}